
import { mixins, Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import WithModel from '@/mixins/withModel';
import moment from 'moment';

@Options({})
export default class dayNavigator extends mixins(WithModel) {

    created(){
        this.localValue = moment(new Date()).startOf('day').toISOString();
        this.emitModel(this.localValue);
    }

    prev(){
        this.localValue = moment(this.localValue).subtract(1, 'day').startOf('day').toISOString();
        this.emitModel(this.localValue);
    }

    next(){
        this.localValue = moment(this.localValue).add(1, 'day').startOf('day').toISOString();
        this.emitModel(this.localValue);
    }

}
